export function trimDateTimestamp(date?: string) {
  return date ? date.replace(/T.*/, '') : '-';
}
